module.exports = __webpack_public_path__ + "static/Uni-00eac050b1f03ed06d356471b461d188.jpg";